<div *ngIf="isLoading | async" class="overlay">
  <ion-spinner name="lines-sharp" class="spinner"></ion-spinner>
</div>
